import { Link } from 'react-router-dom';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background-50 font-['Poppins']">
      {/* Top Navigation Bar */}
      <header className="bg-white border-b border-background-200/70">
        <nav className="px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 max-w-7xl mx-auto">
            <Link to="/" className="flex items-center">
              <h1 className="text-2xl font-bold text-foreground-950">
                <span className="text-primary-500">Suncore</span> International
              </h1>
            </Link>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-left-line"></i>
              </div>
              Back to Home
            </Link>
          </div>
        </nav>
      </header>

      {/* Main Content */}
      <main>
        {/* Hero Banner */}
        <section className="bg-background-100 py-14 md:py-20">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
              Terms of Service
            </h2>
            <p className="text-base text-foreground-600">
              Effective Date: 17 February 2026
            </p>
          </div>
        </section>

        {/* Terms Content */}
        <section className="py-14 md:py-20">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <div className="space-y-10 text-foreground-700 leading-relaxed">

              {/* Section 1 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">1. Introduction</h3>
                <p>
                  Welcome to suncorefze.com (the &ldquo;Website&rdquo;), operated by Suncore International FZE, a company registered and licensed under the Jebel Ali Free Zone Authority (JAFZA), Dubai, UAE. By accessing or using this Website, you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please do not use the Website.
                </p>
              </div>

              {/* Section 2 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">2. Nature of the Website</h3>
                <p>
                  This Website is an informational and product catalogue platform. It does not facilitate online transactions, e-commerce purchases, or payment processing. All product inquiries, quotations, and orders are handled offline through direct communication with our sales team.
                </p>
              </div>

              {/* Section 3 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">3. Use of the Website</h3>
                <p className="mb-3">
                  You agree to use this Website only for lawful purposes and in a manner that does not infringe the rights of, restrict, or inhibit the use and enjoyment of this Website by any third party. You may not:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Use the Website for any fraudulent or unlawful purpose</li>
                  <li>Attempt to gain unauthorised access to any part of the Website or its systems</li>
                  <li>Reproduce, duplicate, copy, or redistribute any Website content without prior written consent</li>
                  <li>Use automated tools to scrape, crawl, or extract data from the Website</li>
                </ul>
              </div>

              {/* Section 4 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">4. Intellectual Property</h3>
                <p>
                  All content on this Website &mdash; including text, images, logos, brand names (such as ITN), product descriptions, and design &mdash; is the property of Suncore International FZE or its licensors. The trademarks SKF, FAG, TIMKEN, ASAHI, FYH, NSK, KOYO, NTN, and URB are the property of their respective owners. Unauthorised use of any content is strictly prohibited.
                </p>
              </div>

              {/* Section 5 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">5. Product Information</h3>
                <p>
                  While we make every effort to ensure that product descriptions, specifications, and availability information on this Website are accurate, we do not warrant that such information is complete, current, or error-free. Product details are provided for general informational purposes only. For confirmed specifications and pricing, please contact our sales team directly.
                </p>
              </div>

              {/* Section 6 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">6. Third-Party Links</h3>
                <p>
                  This Website may contain links to third-party websites. These are provided for convenience only. Suncore International FZE does not endorse, control, or accept responsibility for the content or practices of any linked third-party websites.
                </p>
              </div>

              {/* Section 7 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">7. Limitation of Liability</h3>
                <p>
                  To the fullest extent permitted by applicable law, Suncore International FZE shall not be liable for any direct, indirect, incidental, consequential, or special damages arising from or in connection with your use of this Website or reliance on any information provided herein.
                </p>
              </div>

              {/* Section 8 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">8. Disclaimer of Warranties</h3>
                <p>
                  This Website is provided on an &ldquo;as is&rdquo; and &ldquo;as available&rdquo; basis. Suncore International FZE makes no representations or warranties of any kind, express or implied, regarding the Website&rsquo;s operation, accuracy, or availability.
                </p>
              </div>

              {/* Section 9 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">9. Changes to Terms</h3>
                <p>
                  Suncore International FZE reserves the right to update or modify these Terms of Service at any time without prior notice. Your continued use of the Website following any changes constitutes acceptance of the revised terms.
                </p>
              </div>

              {/* Section 10 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">10. Governing Law</h3>
                <p>
                  These Terms of Service shall be governed by and construed in accordance with the rules and regulations of the Jebel Ali Free Zone Authority (JAFZA) and, where applicable, the federal laws of the United Arab Emirates. Any disputes arising from these terms shall be subject to the jurisdiction of the competent courts in Dubai, UAE.
                </p>
              </div>

              {/* Section 11 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">11. Contact</h3>
                <p className="mb-4">
                  For any questions regarding these Terms of Service, please contact us:
                </p>
                <div className="bg-background-100 rounded-lg p-6 space-y-2 text-sm">
                  <div className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center text-primary-500 shrink-0 mt-0.5">
                      <i className="ri-mail-line"></i>
                    </div>
                    <span>
                      <strong className="text-foreground-950">Email:</strong>{' '}
                      <a href="mailto:sales2@suncore-uae.com" className="text-primary-500 hover:text-primary-600 transition-colors">
                        sales2@suncore-uae.com
                      </a>
                    </span>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center text-primary-500 shrink-0 mt-0.5">
                      <i className="ri-phone-line"></i>
                    </div>
                    <span>
                      <strong className="text-foreground-950">Phone:</strong> +971 55 220 1127 / 04 261 5620
                    </span>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center text-primary-500 shrink-0 mt-0.5">
                      <i className="ri-whatsapp-line"></i>
                    </div>
                    <span>
                      <strong className="text-foreground-950">WhatsApp:</strong> +971 55 220 1127
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-foreground-950 text-white py-8">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <p className="text-sm text-white/70">
            &copy; 2025 Suncore International FZE. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}